import React from "react";
import Head from "next/head";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  createStyles,
  Theme,
  makeStyles,
  useTheme,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { useQuery, gql } from "@apollo/client";

import AppBar from "@Components/appBar/appBar";
import SummaryCard from "@Components/posts/summaryCard";
import HeaderBlock from "@Components/posts/headerBlock";
import Section from "@Components/posts/section";
import Footer from "@Components/common/footer";
import client from "@Config/graphCMSInit";
import SEO from "@Components/common/seo";

const GET_MEMBERS = gql`
  query {
    members(orderBy: createdAt_DESC) {
      name
      introduction
      role
      image {
        url(
          transformation: {
            image: { resize: { width: 400, height: 400, fit: clip } }
            document: { output: { format: webp } }
          }
        )
      }
      nameKana
      affiliation
      type
      social
    }
  }
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spacer: {
      margin: "48px 0",
    },
    textLarge: {
      fontSize: "1rem",
    },
  })
);

export const getStaticProps = async ({ locale }: any) => {
  const cmsQuery = await client.query({
    query: GET_MEMBERS,
  });

  return {
    props: {
      data: cmsQuery.data,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
};

interface StaticProps {
  data: {
    members: {
      name: string;
      introduction: string;
      role: string;
      image: {
        url: string;
      };
      nameKana: string;
      affiliation: string;
      type: "founder" | "collaborator" | "photo_provider" | "info_provider";
      social: string[];
    }[];
  };
}

export default function Home({ data }: StaticProps) {
  const { t: t_common } = useTranslation("common");
  const classes = useStyles();
  const theme = useTheme();

  return (
    <React.Fragment>
      <SEO pageTitle="ときやどについて" />

      <AppBar>
        <Section>
          <HeaderBlock
            title="ときやど制作について"
            subtitle="ときやどの制作者は二人とも、千葉大学建築学科環境系の同じ研究室に所属しています。二人は性格がほぼ真逆ですが、おかげで仕事の分担がうまくいきました。"
          />

          <div className={classes.spacer}>
            <Typography variant="h5" color="textSecondary">
              創設者
            </Typography>
            <Divider />
          </div>
          <Grid container spacing={3}>
            {data
              ? data.members.map((item, i) => {
                  return item.type === "founder" ? (
                    <Grid item sm={6} xs={12} key={i}>
                      <SummaryCard
                        title={`${item.name} (${item.affiliation})`}
                        subtitle={`${item.nameKana}: ${item.role}`}
                        description={item.introduction}
                        image={item.image?.url || ""}
                        social={item.social}
                      />
                    </Grid>
                  ) : null;
                })
              : null}
          </Grid>

          <div className={classes.spacer}>
            <Typography variant="h5" color="textSecondary">
              メディア出演歴
            </Typography>
            <Divider />
          </div>

          <div className={classes.textLarge}>
            2023年4月 TBSラジオ「アシタノカレッジ」出演
            <br />
            2023年10月 ZIP-FM「SUPER CAST」出演
            <br />
            2023年2月 TBSテレビ「マツコの知らない世界」出演
          </div>

          {/* <div className={classes.spacer}>
            <Typography variant="h5" color="textSecondary">
              協力企業様
            </Typography>
            <Divider />
          </div>

          <Grid container spacing={3}>
            {data
              ? data.members.map((item, i) => {
                  return item.type === "collaborator" ? (
                    <Grid item sm={4} xs={12} key={i}>
                      <SummaryCard
                        title={`${item.name} (${item.affiliation})`}
                        subtitle={`${item.nameKana}: ${item.role}`}
                        description={item.introduction}
                        image={item.image?.url || ""}
                        social={item.social}
                      />
                    </Grid>
                  ) : null;
                })
              : null}
              </Grid> */}

          {/*} <Grid container spacing={3}>
            <Grid item sm={6} xs={12}>
              <div className={classes.spacer}>
                <Typography variant="h5" color="textSecondary">
                  写真ご提供者
                </Typography>
                <Divider />
              </div>

              <List aria-label="info providers">
                {data
                  ? data.members.map((item, i) => {
                      return item.type === "photo_provider" ? (
                        <ListItem key={i}>
                          <ListItemAvatar>
                            <Avatar
                              alt={item.name}
                              src={item.image?.url || ""}
                            />
                          </ListItemAvatar>
                          <ListItemText primary={item.name} />
                        </ListItem>
                      ) : null;
                    })
                  : null}
              </List>
            </Grid>

            <Grid item sm={6} xs={12}>
              <div className={classes.spacer}>
                <Typography variant="h5" color="textSecondary">
                  情報ご提供者
                </Typography>
                <Divider />
              </div>

              <List aria-label="info providers">
                {data
                  ? data.members.map((item, i) => {
                      return item.type === "info_provider" ? (
                        <ListItem key={i}>
                          <ListItemAvatar>
                            <Avatar
                              alt={item.name}
                              src={item.image?.url || ""}
                            />
                          </ListItemAvatar>
                          <ListItemText primary={item.name} />
                        </ListItem>
                      ) : null;
                    })
                  : null}
              </List>
            </Grid>
                  </Grid>*/}
        </Section>

        <Footer />
      </AppBar>
    </React.Fragment>
  );
}
